import api from "./api";

export type Team = {
  id: string;
  club_id: string;
  name: string;
  age_group: string | null;
  sport_type: string | null;
  coach_id: string | null;
  created_at: string;
  club?: {
    id: string;
    name: string;
  };
  coach?: {
    id: string;
    email: string;
    full_name: string | null;
  };
  coaches?: {
    id: string;
    email: string;
    full_name: string | null;
  }[];
  _count?: {
    athlete_profiles: number;
  };
};

/**
 * Get team by ID
 */
export async function getTeamById(teamId: string) {
  const { data } = await api.get<Team>(`/teams/${teamId}`);
  return data;
}

/**
 * Get teams for a club
 */
export async function getClubTeams(clubId: string) {
  const { data } = await api.get<Team[]>(`/clubs/${clubId}/teams`);
  return data;
}

/**
 * Assign user to team (athlete or coach)
 */
export async function assignUserToTeam(
  teamId: string,
  userId: string,
  role: "athlete" | "coach"
) {
  const { data } = await api.post(`/teams/${teamId}/assign`, {
    user_id: userId,
    role,
  });
  return data;
}

/**
 * Remove user from team
 */
export async function removeUserFromTeam(teamId: string, userId: string) {
  const { data } = await api.delete(`/teams/${teamId}/members/${userId}`);
  return data;
}

/**
 * Update team
 */
export async function updateTeam(
  teamId: string,
  payload: {
    name?: string;
    age_group?: string;
    sport_type?: string;
    coach_id?: string;
  }
) {
  const { data } = await api.patch<Team>(`/teams/${teamId}`, payload);
  return data;
}

/**
 * Search teams (across all accessible clubs)
 */
export async function searchTeams(query?: string) {
  const qs = query ? `?q=${encodeURIComponent(query)}` : "";
  const { data } = await api.get<Team[]>(`/search/teams${qs}`);
  return data;
}

/**
 * Create a new team in a club
 */
export async function createTeam(
  clubId: string,
  payload: {
    name: string;
    age_group?: string;
    sport_type?: string;
    coach_id?: string;
  }
) {
  const { data } = await api.post<Team>(`/clubs/${clubId}/teams`, payload);
  return data;
}

/**
 * Delete a team
 */
export async function deleteTeam(teamId: string) {
  const { data } = await api.delete(`/teams/${teamId}`);
  return data;
}
